const messages = {
    buttons: {
        productBrochures: "Otkrijte",
    },
    index: {
        title: "INFORMACIJE O PROIZVODU",
        description: "Preuzmite ovde najnovije brošure i letke o našim Bridgestone i Firestone gumama.",
        categories: {
            productBrochures: {
                title: "Brošure proizvoda",
                description: "Brošure Bridgestone i Firestone asortimana guma",
            },
            bDrive: {
              title: "Slike proizvoda",
              description: "Aktuelne slike možete preuzeti na našem B-DRIVE portalu.",
            },
        
          kickback: {
            description: "Učesnicima se kešbek naknade uknjižavaju na osnovu dostavljenih podataka o prihodima.",
          },}
    }
};

export default {
    messages,
};
